import { Link } from "react-router-dom";
import { BoxIcon, Gamepad, Swords } from "lucide-react";
import GameUserList from "./GameUserList";
import GameUserList3d from "./GameUserList3d";
import { useTranslation } from "react-i18next";

import { Loader2, UserPlus, Users, Clock, User } from "lucide-react";
import { useState } from "react";

const PlayerHub = () => {
  const { t } = useTranslation();
  const tabs = [
    { key: "2dgame", label: t("playerHub_tab_2d"), icon: Gamepad },
    { key: "3dgame", label: t("playerHub_tab_3d"), icon: BoxIcon },
  ];

  const [activeTab, setActiveTab] = useState("2dgame");

  return (
    <div className="min-h-[calc(100vh-64px)] px-4 py-12">
      <div className="max-w-4xl mx-auto">
        {/* Page header */}
        <div className="mb-10">
          <div className="flex items-center gap-2 mb-2">
            <Swords size={16} className="text-violet-400" />
            <span className="text-xs font-mono uppercase tracking-widest text-violet-400">
              {t("playerHub_label")}
            </span>
          </div>
          <h1 className="text-3xl font-bold text-white">{t("playerHub_title")}</h1>
          <p className="mt-1 text-zinc-500 text-sm">
            {t("playerHub_description")}
          </p>
        </div>

        {/* Match history */}
        {/* <GameUserList />
        <GameUserList3d /> */}

        <div className="flex gap-1 border-b border-white/8 mb-4">
          {tabs.map(({ key, label, icon: Icon }) => (
            <button
              key={key}
              onClick={() => setActiveTab(key)}
              className={`flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px
              ${
                activeTab === key
                  ? "border-violet-500 text-violet-400"
                  : "border-transparent text-zinc-500 hover:text-zinc-300"
              }`}
            >
              <Icon size={15} />
              {label}
            </button>
          ))}
        </div>
        {/* Content */}
        {activeTab === "2dgame" && (
          <GameUserList />
        )}
        {activeTab === "3dgame" && (
          <GameUserList3d />
        )}
      </div>
    </div>
  );
};

export default PlayerHub;
